import "../../design/latestProjects.css";
import { Container } from "react-bootstrap";
import { VscNotebookTemplate } from "react-icons/vsc";
import { CgMediaLive } from "react-icons/cg";
import { goToLink } from "../../helper/changeLocation";
import Tilt from "react-parallax-tilt";

export default function LatestProjects() {
    return (
        <section id="latestProjects" className="projectsSection">
            <Container>
                <div className="cyberSectionHeader">
                    <span className="sectionTag">PORTFOLIO</span>
                    <h2>LATEST <span className="gradientText">DEPLOYMENTS</span></h2>
                </div>

                <div className="projectCardsGrid">
                    {/* TEMPLATES */}
                    <Tilt glareEnable={true} glareMaxOpacity={0.15} scale={1.02}>
                        <div
                            className="latestProjectCard glass-panel"
                            onClick={() => goToLink("templates")}
                        >
                            <div className="projectCardBadge">MODULES</div>
                            <VscNotebookTemplate className="projectIcon cyanGlow" />
                            <div className="projectText">PREMIUM TEMPLATES</div>
                            <span className="projectActionText">EXPLORE CATALOG →</span>
                        </div>
                    </Tilt>

                    {/* LIVE PROJECTS */}
                    <Tilt glareEnable={true} glareMaxOpacity={0.15} scale={1.02}>
                        <div
                            className="latestProjectCard glass-panel"
                            onClick={() => goToLink("live-projects")}
                        >
                            <div className="projectCardBadge liveBadge">PRODUCTION</div>
                            <CgMediaLive className="projectIcon blueGlow" />
                            <div className="projectText">LIVE PROJECTS</div>
                            <span className="projectActionText">VIEW SYSTEMS →</span>
                        </div>
                    </Tilt>
                </div>
            </Container>
        </section>
    );
}